import { IconButton } from "@mui/material";
import { AddButton } from "app/components/Button/AddButton";
import { FilterSelect } from "app/components/FilterSelect";
import { ThreedotIcon } from "app/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  selectFrontClearanceManufacturerFilter,
  selectFrontClearanceMasterModelFilter,
  selectFrontClearanceYearFilter,
} from "../redux/selector";
import { frontClearanceActions } from "../redux/slice";
import {
  FrontClearanceManufacturerFilter,
  FrontClearanceMasterModelFilter,
  FrontClearanceYearFilter,
} from "../types";
import { useStyles } from "./styles";

type Props = {
  onAddClick?: () => void;
};

const MANUFACTURER_OPTIONS: FrontClearanceManufacturerFilter[] = ["ALL"];
const MASTER_MODEL_OPTIONS: FrontClearanceMasterModelFilter[] = ["ALL"];
const YEAR_OPTIONS: FrontClearanceYearFilter[] = ["ALL"];

const ActionBar = ({ onAddClick }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  const manufacturerFilter = useSelector(
    selectFrontClearanceManufacturerFilter
  );
  const masterModelFilter = useSelector(selectFrontClearanceMasterModelFilter);
  const yearFilter = useSelector(selectFrontClearanceYearFilter);

  const getAllLabel = () => t("FRONT_CLEARANCE.FILTERS.ALL");

  return (
    <div className={styles.root} dir="ltr">
      <div className={styles.actions}>
        <AddButton
          label={t("FRONT_CLEARANCE.ACTIONS.ADD")}
          onClick={onAddClick}
        />
        <IconButton size="small" className={styles.iconButton}>
          <ThreedotIcon />
        </IconButton>
      </div>

      <div className={styles.filters}>
        <FilterSelect
          label={t("FRONT_CLEARANCE.FILTERS.MASTER_MODEL.LABEL")}
          value={masterModelFilter}
          options={MASTER_MODEL_OPTIONS}
          getOptionLabel={getAllLabel}
          onChange={(value) =>
            dispatch(frontClearanceActions.setMasterModelFilter(value))
          }
        />
        <FilterSelect
          label={t("FRONT_CLEARANCE.FILTERS.YEAR.LABEL")}
          value={yearFilter}
          options={YEAR_OPTIONS}
          getOptionLabel={getAllLabel}
          onChange={(value) =>
            dispatch(frontClearanceActions.setYearFilter(value))
          }
        />
        <FilterSelect
          label={t("FRONT_CLEARANCE.FILTERS.MANUFACTURER.LABEL")}
          value={manufacturerFilter}
          options={MANUFACTURER_OPTIONS}
          getOptionLabel={getAllLabel}
          onChange={(value) =>
            dispatch(frontClearanceActions.setManufacturerFilter(value))
          }
        />
      </div>
    </div>
  );
};

export default ActionBar;
